import config from '../config/config';
import CryptoJS from 'crypto-js';

export function encryptData(data) {
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), config.secretKey).toString();
  return JSON.stringify(encryptedData);
}

export function decryptData(name) {
  const decryptedData = CryptoJS.AES.decrypt(name, config.secretKey).toString(CryptoJS.enc.Utf8);   
  return JSON.parse(decryptedData);
}